import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const organizationSectionEntityName = 'organizationSection';
export const organizationSectionColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { title: {
        type: 'string-required',
    }, displayOrder: {
        type: 'number',
    }, description: {
        type: 'string',
    }, key: {
        type: 'string',
    }, requireOrgPermission: {
        type: 'string',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
